<template>
  <div>
    <Menu as="div" class="relative hidden laptop:inline-block">
      <MenuButton
              class="inline-flex w-full justify-center cursor-pointer gap-x-1.5 px-3 py-2 rounded text-sm text-grey-dark hover:bg-light dark:bg-white/10 dark:text-white dark:hover:bg-white/20"
      >
        {{ locale.toUpperCase() }}
        <ChevronDownIcon aria-hidden="true" class="-mr-1 size-5 text-gray-400"/>
      </MenuButton>

      <transition enter-active-class="transition ease-out duration-100"
                  enter-from-class="transform opacity-0 scale-95"
                  enter-to-class="transform scale-100" leave-active-class="transition ease-in duration-75"
                  leave-from-class="transform scale-100" leave-to-class="transform opacity-0 scale-95">
        <MenuItems
                class="absolute right-0 z-10 mt-2 w-16 origin-top-right rounded-md bg-white shadow-lg outline-1 outline-black/5 dark:bg-gray-800 dark:shadow-none dark:-outline-offset-1 dark:outline-white/10">
          <div class="py-1">
            <MenuItem v-for="_locale in locales.filter(l => l.code !== locale)"
                      :key="_locale.code">
              <SiteHydrationSafeLink
                      :to="switchLocalePath(_locale.code)"
                      class="text-gray-700 dark:text-gray-300 block px-4 py-2 text-sm"
              >
                {{ _locale.code.toUpperCase() }}
              </SiteHydrationSafeLink>
            </MenuItem>
          </div>
        </MenuItems>
      </transition>
    </Menu>
    <ul class="laptop:hidden flex ms-1 mt-3">
      <li v-for="_locale in locales"
          :key="_locale.code">
        <SiteHydrationSafeLink
                :class="{'text-black font-medium': locale === _locale.code, 'text-grey hover:text-dark': locale !== _locale.code }"
                :to="switchLocalePath(_locale.code)"
                class=" block px-4 py-2 text-sm text-xl laptop:text-lg"
        >
          {{ _locale.code.toUpperCase() }}
        </SiteHydrationSafeLink>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import {Menu, MenuButton, MenuItem, MenuItems} from '@headlessui/vue'
import {ChevronDownIcon} from '@heroicons/vue/20/solid'

const {locale, locales} = useI18n()
const switchLocalePath = useSwitchLocalePath()
</script>
